import { render, staticRenderFns } from "./ErrorList.vue?vue&type=template&id=68c2bda8"
import script from "./ErrorList.vue?vue&type=script&lang=ts"
export * from "./ErrorList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports